import { ActionContext, ActionTree } from 'vuex';
import { FormState } from './types';
import { RootState } from './../types';
import { MutationTypes } from './mutations';

export enum ActionTypes {
    SET_IS_VISIBLE_FORM = 'SET_IS_VISIBLE_FORM',
    SET_WAS_CLICKED_ON_SHOW_RESULT_PAGE = 'SET_WAS_CLICKED_ON_SHOW_RESULT_PAGE',
    SET_SHOW_RESULT_PAGE = 'SET_SHOW_RESULT_PAGE',
    SET_LABELS = 'SET_LABELS',
    SET_ICONS = 'SET_ICONS',
    SET_IMAGES = 'SET_IMAGES',
    SET_SETTINGS = 'SET_SETTINGS',
    SET_IS_VALID = 'SET_IS_VALID',
    SET_IS_TOUCHED = 'SET_IS_TOUCHED',
    SET_IS_RESSETING_FORM = 'SET_IS_RESSETING_FORM',
    SET_HAS_DEFAULT_VALUES = 'SET_HAS_DEFAULT_VALUES',
    UPDATE_INPUTS = 'UPDATE_INPUTS',
    UPDATE_DATA = 'UPDATE_DATA',
    UPDATE_FUNNEL_STEP = 'UPDATE_FUNNEL_STEP',
    UPDATE_LOCATION = 'UPDATE_LOCATION',
    UPDATE_FUNNEL_STEP_EXTRA = 'UPDATE_FUNNEL_STEP_EXTRA',
    DELETE_DATA = 'DELETE_DATA',
    RESET_FUNNEL_STEP = 'RESET_FUNNEL_STEP'
}

export type Actions = {
    [ActionTypes.SET_IS_VISIBLE_FORM]: (cxt: ActionContext<FormState, RootState>, isVisibleForm: boolean) => void
    [ActionTypes.SET_WAS_CLICKED_ON_SHOW_RESULT_PAGE]: (cxt: ActionContext<FormState, RootState>, wasClickedOnShowResultButton: boolean) => void
    [ActionTypes.SET_SHOW_RESULT_PAGE]: (cxt: ActionContext<FormState, RootState>, showResultPage: boolean) => void
    [ActionTypes.SET_LABELS]: (ctx: ActionContext<FormState, RootState>, labels: Object) => void,
    [ActionTypes.SET_ICONS]: (ctx: ActionContext<FormState, RootState>, icons: Object) => void,
    [ActionTypes.SET_IMAGES]: (ctx: ActionContext<FormState, RootState>, images: Object) => void,
    [ActionTypes.SET_SETTINGS]: (ctx: ActionContext<FormState, RootState>, settings: Object) => void,
    [ActionTypes.UPDATE_INPUTS]: (ctx: ActionContext<FormState, RootState>, payload: Object) => void,
    [ActionTypes.UPDATE_DATA]: (ctx: ActionContext<FormState, RootState>, payload: Object) => void,
    [ActionTypes.DELETE_DATA]: (ctx: ActionContext<FormState, RootState>, payload: Object) => void,
    [ActionTypes.SET_IS_VALID]: (ctx: ActionContext<FormState, RootState>, isValid: boolean) => void,
    [ActionTypes.SET_IS_TOUCHED]: (ctx: ActionContext<FormState, RootState>, isTouched: boolean) => void,
    [ActionTypes.SET_IS_RESSETING_FORM]: (ctx: ActionContext<FormState, RootState>, isResettingForm: boolean) => void,
    [ActionTypes.SET_HAS_DEFAULT_VALUES]: (ctx: ActionContext<FormState, RootState>, hasDefaultValues: boolean) => void,
    [ActionTypes.UPDATE_FUNNEL_STEP]: (ctx: ActionContext<FormState, RootState>, payload: Object) => void,
    [ActionTypes.UPDATE_LOCATION]: (ctx: ActionContext<FormState, RootState>, payload: Object) => void,
    [ActionTypes.UPDATE_FUNNEL_STEP_EXTRA]: (ctx: ActionContext<FormState, RootState>, payload: Object) => void,
    [ActionTypes.RESET_FUNNEL_STEP]: (ctx: ActionContext<FormState, RootState>) => void
}

export const actions: ActionTree<FormState, RootState> = {
    [ActionTypes.SET_IS_VISIBLE_FORM]: ({ commit }, isVisibleForm) => commit(MutationTypes.SET_IS_VISIBLE_FORM, isVisibleForm),
    [ActionTypes.SET_WAS_CLICKED_ON_SHOW_RESULT_PAGE]: ({ commit }, wasClickedOnShowResultButton) => commit(MutationTypes.SET_WAS_CLICKED_ON_SHOW_RESULT_PAGE, wasClickedOnShowResultButton),
    [ActionTypes.SET_SHOW_RESULT_PAGE]: ({ commit }, showResultPage) => commit(MutationTypes.SET_SHOW_RESULT_PAGE, showResultPage),
    [ActionTypes.SET_LABELS]: ({ commit }, labels) => commit(MutationTypes.SET_LABELS, labels),
    [ActionTypes.SET_ICONS]: ({ commit }, icons) => commit(MutationTypes.SET_ICONS, icons),
    [ActionTypes.SET_IMAGES]: ({ commit }, images) => commit(MutationTypes.SET_IMAGES, images),
    [ActionTypes.SET_SETTINGS]: ({ commit }, settings) => commit(MutationTypes.SET_SETTINGS, settings),
    [ActionTypes.UPDATE_INPUTS]: ({ commit }, payload) => commit(MutationTypes.UPDATE_INPUTS, payload),
    [ActionTypes.UPDATE_DATA]: ({ commit }, payload) => commit(MutationTypes.UPDATE_DATA, payload),
    [ActionTypes.DELETE_DATA]: ({ commit }, payload) => commit(MutationTypes.DELETE_DATA, payload),
    [ActionTypes.SET_IS_VALID]: ({ commit }, isValid) => commit(MutationTypes.SET_IS_VALID, isValid),
    [ActionTypes.SET_IS_TOUCHED]: ({ commit }, isTouched) => commit(MutationTypes.SET_IS_TOUCHED, isTouched),
    [ActionTypes.SET_IS_RESSETING_FORM]: ({ commit }, isResettingForm) => commit(MutationTypes.SET_IS_RESSETING_FORM, isResettingForm),
    [ActionTypes.SET_HAS_DEFAULT_VALUES]: ({ commit }, hasDefaultValues) => commit(MutationTypes.SET_HAS_DEFAULT_VALUES, hasDefaultValues),
    [ActionTypes.UPDATE_FUNNEL_STEP]: ({ commit }, payload) => commit(MutationTypes.UPDATE_FUNNEL_STEP, payload),
    [ActionTypes.UPDATE_LOCATION]: ({ commit }, payload) => commit(MutationTypes.UPDATE_LOCATION, payload),
    [ActionTypes.UPDATE_FUNNEL_STEP_EXTRA]: ({ commit }, payload) => commit(MutationTypes.UPDATE_FUNNEL_STEP_EXTRA, payload),
    [ActionTypes.RESET_FUNNEL_STEP]: ({ commit }) => commit(MutationTypes.RESET_FUNNEL_STEP)
};